<template>
  <v-layout
    row
    wrap
    justify-center
  >
    <v-flex
      xs12
      sm8
      md6
    >
      <v-card class="elevation-12 company">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            {{ $t('message.company_registration_title') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form
            novalidate
            @submit.prevent="validateCompany"
          >
            <v-text-field
              v-model="company.ubnNumber"
              name="ubnNumber"
              :label="($t('message.ubn_number'))"
              type="text"
            />
            <v-text-field
              v-model="company.tankNumber"
              required
              name="tankNumber"
              :label="($t('message.tank_number') + ' *')"
              type="text"
              :error-messages="validationErrors['tankNumber']"
            />
            <v-text-field
              v-model="company.name"
              required
              name="name"
              :label="($t('message.company_name') + ' *')"
              type="text"
              :error-messages="validationErrors['name']"
            />
            <v-text-field
              v-model="company.street"
              required
              name="street"
              :label="($t('message.street') + ' *')"
              type="text"
              :error-messages="validationErrors['street']"
            />
            <v-container grid-list-xl>
              <v-layout
                row
                justify-space-between
              >
                <v-flex xs6>
                  <v-text-field
                    v-model="company.houseNumber"
                    required
                    name="houseNumber"
                    :label="($t('message.house_number') + ' *')"
                    type="text"
                    :error-messages="validationErrors['houseNumber']"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="company.houseSuffix"
                    name="house_suffix"
                    :label="$t('message.house_suffix')"
                    type="text"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-text-field
              v-model="company.postcode"
              required
              name="postcode"
              :label="($t('message.postcode') + ' *')"
              type="text"
              :error-messages="validationErrors['postcode']"
            />
            <v-text-field
              v-model="company.city"
              required
              name="city"
              :label="($t('message.city') + ' *')"
              type="text"
              :error-messages="validationErrors['city']"
            />
            <v-select
              v-model="company.countryCode"
              :label="($t('message.country') + ' *')"
              :items="countries['nl']"
              item-text="name"
              item-value="code"
              :error-messages="validationErrors['country']"
              required
            />
            <v-select
              v-if="company.countryCode == 'nld'"
              v-model="company.state"
              :items="states"
              item-value="id"
              item-text="id"
              :label="($t('message.state') + ' *')"
              :error-messages="validationErrors['state']"
            />
            <v-text-field
              v-else
              v-model="company.state"
              name="state"
              :label="($t('message.state') + ' *')"
              type="text"
              :error-messages="validationErrors['state']"
            />
            <v-text-field
              v-model="company.phone"
              name="phone"
              :label="$t('message.phone')"
              type="text"
            />
            <v-text-field
              v-model="company.email"
              name="email"
              :label="($t('message.email') + ' *')"
              type="text"
              :error-messages="validationErrors['email']"
            />
            <v-text-field
              v-model="company.cocNumber"
              name="coc_number"
              :label="($t('message.coc_number'))"
              type="text"
              :error-messages="validationErrors['cocNumber']"
            />
            <v-text-field
              v-model="company.vatNumber"
              name="vatNumber"
              :label="($t('message.vat_number'))"
              type="text"
              :error-messages="validationErrors['vatNumber']"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            flat
            @click="$emit('close')"
          >
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="validateCompany"
          >
            {{ $t('message.register_company_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="showError"
        color="error"
        :multi-line="true"
      >
        {{ $t('message.general_form_error') }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
      <v-snackbar
        v-model="showServiceError"
        color="error"
        :multi-line="true"
      >
        {{ serviceError }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
export default {
  name: 'Company',
  mixins: [validationMixin],
  data: (vm) => ({
    company: {
      ubnNumber: '',
      tankNumber: '',
      name: '',
      street: '',
      houseNumber: '',
      houseSuffix: '',
      postcode: '',
      city: '',
      countryCode: 'nld',
      state: '',
      phone: '',
      email: '',
      cocNumber: '',
      vatNumber: '',
    },
    states: [
      'Drenthe',
      'Flevoland',
      'Fryslân',
      'Gelderland',
      'Groningen',
      'Limburg',
      'Noord-Brabant',
      'Noord-Holland',
      'Overijssel',
      'Utrecht',
      'Zeeland',
      'Zuid-Holland',
    ],
    countries: {
      nl: [
        { code: 'bel', name: 'België' },
        { code: 'deu', name: 'Duitsland' },
        { code: 'fra', name: 'Frankrijk' },
        { code: 'nld', name: 'Nederland' },
      ],
      en: [
        { code: 'bel', name: 'Belgium' },
        { code: 'fra', name: 'France' },
        { code: 'deu', name: 'Germany' },
        { code: 'nld', name: 'Netherlands' },
      ],
    },
    companyError: '',
    serviceError: '',
    showError: false,
    showServiceError: false,
  }),
  computed: {
    validationErrors() {
      const v = this.$v.company
      function errorsFromArray(fieldName, validations) {
        return validations
          .filter((obj) => {
            return !v[fieldName][obj.key]
          })
          .map((o) => o.message)
      }

      const errors = {
        name: this.$t('message.required_field'),
        tankNumber: this.$t('message.required_field'),
        street: this.$t('message.required_field'),
        houseNumber: this.$t('message.required_field'),
        city: this.$t('message.required_field'),
        countryCode: this.$t('message.required_field'),
        state: this.$t('message.required_field'),
        postcode: this.$t('message.required_field'),
        email: errorsFromArray('email', [
          { key: 'email', message: this.$t('message.invalid_email') },
          { key: 'required', message: this.$t('message.required_field') },
        ]),
        // , cocNumber: this.$t('message.required_field')
        // , vatNumber: this.$t('message.required_field')
      }

      const newErrors = {}
      Object.keys(errors).forEach((fieldName) => {
        newErrors[fieldName] =
          this.$v.company[fieldName].$dirty &&
          this.$v.company[fieldName].$invalid
            ? errors[fieldName]
            : undefined
      })

      return newErrors
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'registrationError') {
        this.serviceError = mutation.payload.message
        this.showServiceError = true
      }
    })
  },
  mounted() {
    this.company.country = 'Nederland'
  },
  methods: {
    validateCompany() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('registerCompany', this.company)
      } else {
        this.showError = true
      }
    },
  },
  validations: {
    company: {
      tankNumber: {
        required,
      },
      name: {
        required,
      },
      street: {
        required,
      },
      houseNumber: {
        required,
      },
      postcode: {
        required,
      },
      city: {
        required,
      },
      countryCode: {
        required,
      },
      state: {
        required,
      },
      // , cocNumber: {
      //   required
      // }
      // , vatNumber: {
      //   required
      // }
      email: {
        required,
        email,
      },
    },
  },
}
</script>
